var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.246 0h73.508c6.043 0 10.98 4.9375 10.98 10.98v78.035c0 6.043-4.9375 10.98-10.98 10.98h-73.508c-6.043 0-10.98-4.9375-10.98-10.98v-78.035c0-6.043 4.9375-10.98 10.98-10.98zm19.016 76.578v-53.156h20.07c3.5273 0 6.2227 0.17188 8.0898 0.50781 7.793 1.293 12.449 6.7734 12.449 14.836 0 12.301-8.9727 16.137-19.922 16.137h-13.637v21.676h-7.0547zm7.0547-27.914h13.734c6.793 0 12.547-1.8789 12.547-9.6875 0-4.0312-2.082-7.7266-6.125-8.8438-1.1875-0.30859-3.3789-0.46875-6.5586-0.46875h-13.598v19.004zm-24.676-42.703h70.73c3.5078 0 6.3867 2.8828 6.3867 6.3867v75.301c0 3.5117-2.8789 6.3867-6.3867 6.3867h-70.73c-3.5117 0-6.3867-2.8789-6.3867-6.3867v-75.301c0-3.5078 2.8789-6.3867 6.3867-6.3867zm70.73 3.4219h-70.73c-1.6367 0-2.9688 1.332-2.9688 2.9688v75.301c0 1.6367 1.332 2.9688 2.9688 2.9688h70.73c1.6328 0 2.9648-1.332 2.9648-2.9688v-75.301c0-1.6367-1.332-2.9688-2.9648-2.9688zm1.3867-5.9609h-73.508c-4.1523 0-7.5586 3.4062-7.5586 7.5586v78.035c0 4.1523 3.4062 7.5586 7.5586 7.5586h73.508c4.1523 0 7.5586-3.4062 7.5586-7.5586v-78.035c0-4.1523-3.4062-7.5586-7.5586-7.5586z",
    fill: "#c39a36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParking);
export default __webpack_public_path__ + "static/media/parking.bed8d45c.svg";
export { ForwardRef as ReactComponent };